import SearchBar from "@Front/Components/DesignSystem/SearchBar";
import Button from "@Front/Components/DesignSystem/Button";
import classes from "../classes.module.scss";

type SearchBarSectionProps = {
	compact?: boolean;
	onSearchChange: (value: string) => void;
	bottomButton?: {
		text: string;
		link?: string;
		onClick?: () => void;
	};
	onBottomButtonClick: () => void;
};

export function SearchBarSection(props: SearchBarSectionProps): React.JSX.Element {
	const { compact = false, onSearchChange, bottomButton, onBottomButtonClick } = props;

	return (
		<div className={classes["searchbar"]}>
			<SearchBar compact={compact} placeholder="Chercher" onChange={onSearchChange} />
			{bottomButton && (
				<div className={classes["responsive-button-container"]}>
					<Button fullwidth onClick={onBottomButtonClick}>
						{bottomButton.text}
					</Button>
				</div>
			)}
		</div>
	);
}
